<ng-template #content let-modal>

    <div class="modal-header">
        <h5 class="modal-title white" id="exampleModalLabel">Entrega</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="closeModal()">
            <span aria-hidden="true"><img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20"></span>
        </button>
    </div>

    <div class="modal-body">
        <div class="container">
            <form [formGroup]="formGroup">
                <div class="row">
                    <div class="col-lg-12">

                        <h6 class="subtitulo-pack-form">Tipo de entrega</h6>

                        <div class="radio-btn-group">
                            <div class="radio" *ngIf="showSendContactAddress">
                                <input id="dp-client" type="radio" name="delivery-price" [value]="3"
                                       (click)="changeDeliveryPrice($event.target.value)" [checked]="model.type === 3"/>
                                <label for="dp-client">
                                    Enviar a la dirección de contacto
                                    <b>{{ showCorreosOption ? '9,00 €' : '3,00 €' }}</b>
                                </label>
                            </div>
                            <div class="radio">
                                <input id="dp-msg" type="radio" name="delivery-price" [value]="2"
                                       (click)="changeDeliveryPrice($event.target.value)" [checked]="model.type === 2"/>
                                <label for="dp-msg">Enviar a otra dirección
                                    <b>{{ showCorreosOption ? '9,00 €' : '3,00 €' }}</b>
                                </label>
                            </div>
                            <div class="radio" *ngIf="showCorreosOption">
                                <input id="dp-mail" type="radio" name="delivery-price" [value]="1"
                                       (click)="changeDeliveryPrice($event.target.value)" [checked]="model.type === 1"/>
                                <label for="dp-mail">
                                    Envío a Correos
                                    <b>6,00 €</b>
                                </label>
                            </div>
                            <div class="radio" *ngIf="false">
                                <input id="dp-free" type="radio" name="delivery-price" [value]="0"
                                       (click)="changeDeliveryPrice($event.target.value)" [checked]="model.type === 0"/>
                                <label for="dp-free">
                                    Entrega en PDV
                                    <b>Gratis</b>
                                </label>
                            </div>
                        </div>

                        <div class="bb-line"></div>

                        <div class="jumbotron-norm mt-2" *ngIf="model.type === 0 && pdv !== null">
                            <h6 class="pdv-nombre mt-2 verde"><b>{{ pdv.info.name}}</b></h6>
                            <h6 class="pdv-dir">{{ pdv.address.address + ', ' + pdv.address.location + ', ' + pdv.address.province }}</h6>
                            <h6 class="pdv-horarios">
                                Teléfono : {{ pdv.info.phone }} <br>
                                E-mail: {{ pdv.info.email }}
                            </h6>
                        </div>

                        <div *ngIf="model.type === 1">
                            <h6 class="subtitulo-pack-form">Buscador de dirección:</h6>

                            <div class="form-row">
                                <div class="col-lg-4">
                                    <mat-form-field>
                                        <mat-label>Código postal</mat-label>
                                        <input matInput type="text" formControlName="zip" required (input)="getOfficesByZip($event.target.value)">
                                        <span *ngIf="isLoading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    </mat-form-field>
                                    <mat-error class="mb-3" *ngIf="showErrorZip">
                                        Error del servidor. Inténtelo de nuevo más tarde
                                    </mat-error>
                                </div>

                                <!--<div class="col-lg-8">
                                    <mat-form-field>
                                        <mat-label>Seleccionar punto de venta</mat-label>
                                        <select matNativeControl id="offices" formControlName="office" [(ngModel)]="office" required>
                                            <option *ngFor="let office of offices" [ngValue]="office">{{ office.name }}</option>
                                        </select>
                                    </mat-form-field>
                                </div>-->

                            </div>
                        </div>

                        <div class="form-row" *ngIf="model.type === 2">
                            <div class="col-lg-12 mt-1" *ngIf="userForm && !showSendContactAddress" align="center">
                                <button class="btn btn-sm btn-green" (click)="copyUserData()">Usar datos del cliente</button>
                            </div>

                            <div class="col-lg-9 mt-1">
                                <mat-form-field>
                                    <mat-label>Destinatario*</mat-label>
                                    <input type="text" matInput formControlName="full_name">
                                </mat-form-field>
                            </div>

                            <div class="col-lg-3 mt-1">
                                <mat-form-field>
                                    <mat-label>Teléfono de contacto*</mat-label>
                                    <input type="text" matInput formControlName="phone">
                                </mat-form-field>
                            </div>

                            <!-- <div class="col-lg-3 mt-1">
                                <mat-form-field>
                                    <mat-label>Tipo de vía*</mat-label>
                                    <select matNativeControl formControlName="road_type">
                                        <option *ngFor='let roadType of roadTypes' value="{{ roadType.code }}">{{ roadType.code }}</option>
                                    </select>
                                </mat-form-field>
                            </div> -->

                            <div class="col-lg-6 mt-1">
                                <mat-form-field>
                                    <mat-label>Nombre de la vía*</mat-label>
                                    <input type="text" matInput matGoogleMapsAutocomplete formControlName="address"
                                           [types]="['address']"
                                           [country]="country"
                                           (onAutocompleteSelected)="onAutocompleteSelected($event)">
                                </mat-form-field>
                            </div>

                            <div class="col-lg-1 mt-1">
                                <mat-form-field>
                                    <mat-label>Número*</mat-label>
                                    <input type="text" matInput formControlName="number">
                                </mat-form-field>
                            </div>

                            <div class="col-lg-2 mt-1">
                                <mat-form-field>
                                    <mat-label>Planta</mat-label>
                                    <input type="text" matInput formControlName="floor" [matAutocomplete]="autoFloorTypes">
                                    <mat-autocomplete #autoFloorTypes="matAutocomplete" [panelWidth]="200">
                                        <mat-option *ngFor="let option of floorFilteredOptions | async" [value]="option.code">
                                            {{ option.description }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-1 mt-1">
                                <mat-form-field>
                                    <mat-label>Puerta</mat-label>
                                    <input type="text" matInput formControlName="door">
                                </mat-form-field>
                            </div>

                            <div class="col-lg-2 mt-1">
                                <mat-form-field>
                                    <mat-label>Escalera</mat-label>
                                    <input type="text" matInput formControlName="stairway" [matAutocomplete]="autoStaircaseTypes">
                                    <mat-autocomplete #autoStaircaseTypes="matAutocomplete" [panelWidth]="200">
                                        <mat-option *ngFor="let option of staircaseFilteredOptions | async" [value]="option.code">
                                            {{ option.description }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>

                            <div class="col-lg-12 mt-1">
                                <mat-form-field>
                                    <mat-label>Información adicional</mat-label>
                                    <input type="text" matInput formControlName="additional_info">
                                </mat-form-field>
                            </div>

                            <div class="col-lg-3 mt-1">
                                <mat-form-field>
                                    <mat-label>Código Postal*</mat-label>
                                    <input type="number" matInput formControlName="zip" (input)="onChangeZip($event.target.value)">
                                </mat-form-field>
                            </div>

                            <div class="col-lg-5 mt-1">
                                <mat-form-field>
                                    <mat-label>Localidad*</mat-label>
                                    <input type="text" matInput formControlName="city">
                                </mat-form-field>
                            </div>

                            <div class="col-lg-4 mt-1">
                                <mat-form-field>
                                    <mat-label>Provincia</mat-label>
                                    <select matNativeControl formControlName="province">
                                        <option *ngFor="let province of provinces"
                                                value="{{province.code}}">{{province.code}}</option>
                                    </select>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Dirección elegida -->


                        <div class="mb-2" *ngIf="model.type === 1 && offices.length > 0">
                            <h6 class="subtitulo-pack-form">
                                Datos de punto de entrega
                            </h6>

                            <div class="offices">
                                <div class="office jumbotron-norm mt-2" [ngClass]="{ 'active' : office == item }"
                                     *ngFor="let item of offices, index as i" (click)="selectOffice(i, item)">
                                    <h6 class="pdv-nombre mt-2 verde"><b>{{ item.name}}</b></h6>
                                    <h6 class="pdv-codigo">Código: {{ item.id }}</h6>
                                    <h6 class="pdv-dir">{{ item.address.completeAddress }}</h6>
                                    <h6 class="pdv-horarios" *ngFor="let c of item.calendar">
                                        {{ c.day + " " + c.openingTimesDescription.toLowerCase() }}
                                    </h6>
                                </div>
                            </div>
                        </div>

                        <!-- Confirmación -->

                        <div class="jumbotron-norm mb-4">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="p-2 bd-highlight cong-tienda">
                                    <h6 class="pdv-nombre">
                                        <img src="./assets/img/credit-card.svg" class="img-fluid ico-title" width="17">
                                        Precio del servicio de entrega
                                    </h6>
                                </div>
                                <small class="text-muted">
                                    <h6 class="pdv-nombre verde mt-2">
                                        <b>{{ deliveryPrice == 0 ? 'GRATIS' : deliveryPrice + ",00€" }}</b>
                                    </h6>
                                </small>
                            </div>
                        </div>

                        <div class="mb-3" align="center">
                            <br><br>
                            <button type="button" class="btn btn-green btn-sm" (click)="confirmDelivery()" [disabled]="showErrorZip && model.type === 1">
                                Confirmar entrega
                            </button>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    </div>

</ng-template>

<!-- <h6 class="subtitulo-pack-form" [ngClass]="{ 'error' : errorForm }">Método de entrega</h6> -->

<div class="jumbotron-form2 mt-3" [ngClass]="{ 'error' : errorForm }" style="min-height: 50px;">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <span class="label-ad-text2">Dirección de entrega</span>
            <br>
            <!-- Dirección -->
            <span class="label-ad-text">{{ confirmedAddress }}</span>
        </div>
        <small class="text-muted btn-muted">
            <button class="btn btn-green btn-sm" role="button" (click)="open(content)">
                {{ confirmedAddress && confirmedAddress !== '' ? 'Modificar' : 'Añadir'}}
            </button>
        </small>
    </div>
</div>
